import { createUseStyles } from 'react-jss'
import { mediumGrey, lightGrey } from '../../../styles/const/colors'
import { zIndex10 } from '../../../styles/const/common'

const useStyles = createUseStyles({
  media: {
    width: '100%',
    paddingTop: '100%',
    backgroundColor: lightGrey,
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    borderRadius: 2,
    position: 'relative',
    cursor: onMediaClick => !!onMediaClick && 'pointer'
  },
  overlay: {
    position: 'absolute',
    top: 5,
    right: 5,
    backgroundColor: 'white',
    padding: 3,
    border: `1px solid ${mediumGrey}`,
    borderRadius: 2,
    fontSize: 8
  },
  deleteBtn: {
    position: 'absolute',
    padding: 5,
    zIndex: zIndex10,
    top: 0,
    right: 0,
    backgroundColor: 'transparent',
    width: 22,
    height: 22
  }
})

export default useStyles
